import useGroups from "@/hooks/useGroups";
import useTraces from "@/hooks/useTraces";
import useUsers from "@/hooks/useUsers";
import { useEffect } from "react";

interface IDataProviders {
  children: React.ReactNode;
}

const DataProviders: React.FC<IDataProviders> = ({ children }) => {
  const { getGroups } = useGroups();
  const { getUsers } = useUsers();
  const { getTraces } = useTraces();

  useEffect(() => {
    getGroups();
    getUsers();
    getTraces();
  }, []);

  return <>{children}</>;
};

export default DataProviders;
